import { Navigate } from 'react-router-dom';

const useSelfReferralCode = () => {
  const selfReferralCode = sessionStorage.getItem('selfReferralCode');
  if (!selfReferralCode) throw new Error('no service code');
  return selfReferralCode;
};

const SelfReferralRedirect = () => {
  const selfReferralCode = useSelfReferralCode();

  return <Navigate to={`/self-referral/${selfReferralCode}`} />;
};

export { SelfReferralRedirect };
